"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var d3 = require("d3");
var _ = require("lodash");
var Mustache = require("mustache");
var event = require("./event");
var log_1 = require("./log");
var logger = log_1.getLogger("visualizer");
var DataSourceType;
(function (DataSourceType) {
    DataSourceType[DataSourceType["CSV"] = 1] = "CSV";
    DataSourceType[DataSourceType["TSV"] = 2] = "TSV";
    DataSourceType[DataSourceType["JSON"] = 3] = "JSON";
    DataSourceType[DataSourceType["TEXT"] = 4] = "TEXT";
})(DataSourceType = exports.DataSourceType || (exports.DataSourceType = {}));
var DataLoader = /** @class */ (function () {
    function DataLoader(options) {
        this.fileMissing = false;
        this.data = {};
        this.dataSources = options.sources;
        this.dataTypes = Object.keys(this.dataSources).filter(function (x) { return x[0] !== "@"; });
        this.debugMode = options.debug || false;
    }
    DataLoader.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var checkDependence, paths, _i, _a, dt, loadOrder, _loop_1, this_1, _b, loadOrder_1, key;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        checkDependence = function (dt, orig) {
                            var dp = _this.dataSources[dt].dependsOn;
                            if (!dp) {
                                return true;
                            }
                            var result = true;
                            for (var _i = 0, dp_1 = dp; _i < dp_1.length; _i++) {
                                var p = dp_1[_i];
                                if (p === orig) {
                                    return false;
                                }
                                result = result && checkDependence(p, orig);
                            }
                            return result;
                        };
                        event.emit(event.DATA_LOADING_STARTED);
                        if (!(window.gon && window.gon.urls)) return [3 /*break*/, 2];
                        return [4 /*yield*/, axios_1.default.get(window.gon.urls.chosen_file_paths)];
                    case 1:
                        paths = _c.sent();
                        this.selectedFiles = paths.data;
                        this.metadata = _.mapValues(this.selectedFiles, function (x) {
                            if (x instanceof Array) {
                                return x.map(function (z) { return z.metadata; });
                            }
                            return x.metadata;
                        });
                        _c.label = 2;
                    case 2:
                        for (_i = 0, _a = this.dataTypes; _i < _a.length; _i++) {
                            dt = _a[_i];
                            if (!checkDependence(dt, dt)) {
                                logger.error("Circular data dependency detected");
                                return [2 /*return*/];
                            }
                        }
                        loadOrder = this.dataTypes.sort(function (a, b) {
                            var da = _this.dataSources[a];
                            var db = _this.dataSources[b];
                            if (_.includes(da.dependsOn, b)) {
                                return 1;
                            }
                            else if (_.includes(db.dependsOn, a)) {
                                return -1;
                            }
                            return 0;
                        });
                        _loop_1 = function (key) {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this_1.loadDataFor(key).then(function (rawData) {
                                            var def = _this.dataSources[key];
                                            var data = rawData;
                                            if (typeof def.dataPath === "string") {
                                                data = _.get(rawData, def.dataPath);
                                            }
                                            else if (typeof def.dataPath === "function") {
                                                data = def.dataPath.call(_this, rawData);
                                            }
                                            _this.data[key] = data;
                                            if (typeof def.loaded === "function") {
                                                var result = def.loaded.call(_this, data, def);
                                                if (typeof result !== "undefined") {
                                                    _this.data[key] = result;
                                                }
                                            }
                                            if (_this.debugMode) {
                                                // tslint:disable-next-line
                                                console.log(key);
                                            }
                                        })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _b = 0, loadOrder_1 = loadOrder;
                        _c.label = 3;
                    case 3:
                        if (!(_b < loadOrder_1.length)) return [3 /*break*/, 6];
                        key = loadOrder_1[_b];
                        return [5 /*yield**/, _loop_1(key)];
                    case 4:
                        _c.sent();
                        _c.label = 5;
                    case 5:
                        _b++;
                        return [3 /*break*/, 3];
                    case 6:
                        if (this.debugMode) {
                            // tslint:disable-next-line
                            console.log(this.data);
                        }
                        event.emit(event.DATA_LOADING_FINISHED);
                        event.emit("bvd3.dataLoaded", this.data);
                        return [2 /*return*/, Promise.resolve(this.data)];
                }
            });
        });
    };
    DataLoader.prototype.loadDataFor = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var def, createPromise, dataType, d3Loader, tasks_1, origLoader;
            var _this = this;
            return __generator(this, function (_a) {
                def = this.dataSources[key];
                createPromise = function (path, loader) {
                    return new Promise(function (fullfill, reject) {
                        // If file key is optional
                        if (path === null) {
                            fullfill(null);
                            return;
                        }
                        var dsvHasHeader = def.dsvHasHeader !== false;
                        var dsvRowParser = def.type === DataSourceType.CSV || def.type === DataSourceType.TSV ?
                            def.dsvRowDef === undefined ?
                                def.dsvRowParser : function (data) {
                                var result = {};
                                _.forOwn(data, function (value, key) {
                                    var rowDef = def.dsvRowDef[key] || ["string"];
                                    var k = rowDef[1] || key;
                                    switch (rowDef[0]) {
                                        case "int":
                                            result[k] = parseInt(value);
                                            break;
                                        case "float":
                                            result[k] = parseFloat(value);
                                            break;
                                        case "string":
                                            result[k] = value;
                                            break;
                                        default: break;
                                    }
                                });
                                return result;
                            } : undefined;
                        var init = {};
                        if (def.includeCredentials) {
                            init.credentials = "include";
                        }
                        loader.call(_this, path, init).then(function (rawData) {
                            var data;
                            if ((def.type === DataSourceType.CSV || def.type === DataSourceType.TSV) && rawData.charAt(0) === "#") {
                                data = rawData.substr(1);
                            }
                            else {
                                data = rawData;
                            }
                            switch (def.type) {
                                case DataSourceType.CSV:
                                    data = dsvHasHeader ? d3.csvParse(data, dsvRowParser) : d3.csvParseRows(data, dsvRowParser);
                                    break;
                                case DataSourceType.TSV:
                                    data = dsvHasHeader ? d3.tsvParse(data, dsvRowParser) : d3.tsvParseRows(data, dsvRowParser);
                                    break;
                            }
                            fullfill(data);
                        }).catch(function (error) {
                            logger.error("Error loading " + key + ": " + error);
                            reject(error);
                        });
                    });
                };
                dataType = def.type || DataSourceType.TEXT;
                d3Loader = dataType === DataSourceType.JSON ? d3.json : d3.text;
                if (typeof def.loader === "function") {
                    tasks_1 = [];
                    origLoader = function (options) {
                        tasks_1.push(createPromise(_this.apiPath(key, options), d3Loader));
                    };
                    def.loader.call(this, origLoader);
                    return [2 /*return*/, Promise.all(tasks_1)];
                }
                else if (def.multiple) {
                    return [2 /*return*/, Promise.all(this.apiPathMultiple(key).map(function (x) { return createPromise(x, d3Loader); }))];
                }
                else {
                    return [2 /*return*/, createPromise(this.apiPath(key), d3Loader)];
                }
                return [2 /*return*/];
            });
        });
    };
    DataLoader.prototype.apiPathMultiple = function (type) {
        return this._apiPath(type, null, true);
    };
    DataLoader.prototype.apiPath = function (type, options) {
        if (options === void 0) { options = null; }
        return this._apiPath(type, options);
    };
    DataLoader.prototype._apiPath = function (type, options, multiple) {
        if (options === void 0) { options = null; }
        if (multiple === void 0) { multiple = false; }
        var def = this.dataSources[type];
        if (typeof def.url === "string") {
            return Mustache.render(def.url, options ? options : this);
        }
        else if (typeof def.fileKey === "string") {
            if (window.BVD_CUSTOM_DATA_PROVIDER) {
                var dataList = window.BVD_CUSTOM_DATA_PROVIDER;
                return dataList.find(function (d) { return d.fileKey === def.fileKey; }).url;
            }
            var info = this.selectedFiles[def.fileKey];
            if (!info) {
                throw new Error("File key misconfigured. The visualization module required a key that is not available in this analysis.");
            }
            if (multiple) {
                if (info instanceof Array) {
                    return info.map(function (x) { return x.url; });
                }
                else {
                    logger.error("multiple = true for file key \"" + type + "\", but this key doesn't accept multiple files.");
                }
            }
            else {
                if (info instanceof Array) {
                    logger.error("multiple = false for file key \"" + type + "\", but this key accepts multiple files.");
                }
                else {
                    return info.url;
                }
            }
            return null;
        }
        logger.error("Data source is invalid for type " + type);
        return null;
    };
    return DataLoader;
}());
exports.DataLoader = DataLoader;
//# sourceMappingURL=data-loader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/data-loader.js
// module id = 1191
// module chunks = 0 1